import global from './Global';
import variables from './Variables';

export default {
  global,
  variables,
  ...variables,
};
